import React, { useContext, useRef, useState } from 'react';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import CollegeDetailsView from './CollegeDetailsView';
import moment from 'moment';
import toast from 'react-hot-toast';
import Instruction from '../../Documentation/Instruction';


interface invoiceManagementProps {
  onClose: () => void;
}

function CollegeVerification({ onClose }: invoiceManagementProps) {
  const { collegeId } = useContext(FirebaseContext);
  const ref = useRef<any>(null);
  const [selectedCollege, setSelectedCollege] = useState<any>(null);
  const [confirmDeleteCollege, setConfirmDeleteCollege] = useState<any | null>(null);
  const [confirmApproveCollege, setConfirmApproveCollege] = useState<any | null>(null);

  const handleCollegeClick = async (collegeId: string) => {
    try {
      const instance = await getAxiosTokenInstance();
      const res = await instance.get(`/register/getCollegeById/${collegeId}`);
      if (res.data?.college) {
        setSelectedCollege(res.data.college);
      } else {
        toast.error('College not found');
      }
    } catch (err) {
      toast.error('Failed to fetch college details');
      console.error(err);
    }
  };

  const getPendingColleges = async () => {
    const instance = await getAxiosTokenInstance();
    const resp = await instance.get('/register/forAproval');
    if (resp.data.statusCode !== 200) {
      throw new Error(resp.data.message || 'API Error');
    }
    return resp.data.pendingColleges;
  };

  const { data: tableData = [], refetch } = useQuery('pendingColleges', getPendingColleges);

  const confirmDelete = async () => {
    if (!confirmDeleteCollege) return;
    try {
      const instance = await getAxiosTokenInstance();
      await instance.post('/register/approveCollege', {
        collegeId: confirmDeleteCollege._id,
        status: 'reject',
      });
      refetch();
      setConfirmDeleteCollege(null);
    } catch (err) {
      console.error(err);
    }
  };

  const confirmApprove = async () => {
    if (!confirmApproveCollege) return;
    try {
      const instance = await getAxiosTokenInstance();
      await instance.post('/register/approveCollege', {
        collegeId: confirmApproveCollege._id,
        status: 'approve',
      });
      refetch();
      setConfirmApproveCollege(null);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Main title="College Verification" width="100%" height="100%">
      <Header>
        <div className="flex"></div>
        <div className="flex">
          <Button type="print" tableRef={ref.current}>Print</Button>
          <Button type="excel" tableRef={ref.current}>Excel</Button>
          <Instruction keyId={'collegeVerifcation'}/>
          <Button type="close" onClick={onClose}>Close</Button>
        </div>
      </Header>

      <Body>
        {confirmDeleteCollege && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-xl w-[420px] text-center">
              {confirmDeleteCollege.logo && (
                <img
                  src={confirmDeleteCollege.logo}
                  alt="College Logo"
                  className="w-20 h-20 mx-auto mb-4 rounded-full border border-gray-300 shadow"
                />
              )}
              <h2 className="text-lg font-semibold text-gray-800 mb-2">Confirm Deletion</h2>
              <p className="text-sm text-gray-600 mb-6">
                Are you sure you want to delete <strong className="text-red-600">{confirmDeleteCollege.collegeName}</strong>?<br />
                This action cannot be undone.
              </p>
              <div className="flex justify-center gap-4">
                <Button type="close" onClick={() => setConfirmDeleteCollege(null)}>
                  Cancel
                </Button>
                <Button type="delete" onClick={confirmDelete}>
                  Confirm Delete
                </Button>
              </div>
            </div>
          </div>
        )}

        {confirmApproveCollege && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-xl w-[420px] text-center">
              {confirmApproveCollege.logo && (
                <img
                  src={confirmApproveCollege.logo}
                  alt="College Logo"
                  className="w-20 h-20 mx-auto mb-4 rounded-full border border-gray-300 shadow"
                />
              )}
              <h2 className="text-lg font-semibold text-gray-800 mb-2">Confirm Approval</h2>
              <p className="text-sm text-gray-600 mb-6">
                Are you sure you want to approve <strong className="text-green-600">{confirmApproveCollege.collegeName}</strong>?
              </p>
              <div className="flex justify-center gap-4">
                <Button type="close" onClick={() => setConfirmApproveCollege(null)}>
                  Cancel
                </Button>
                <Button type="submit" onClick={confirmApprove}>
                  Confirm Approve
                </Button>
              </div>
            </div>
          </div>
        )}

        {selectedCollege ? (
          <CollegeDetailsView
            college={selectedCollege}
            onBack={() => setSelectedCollege(null)}
            refetchData={refetch}
          />
        ) : (
          <div ref={ref} className="h-[75vh] pt-2 printable overflow-auto">
            <Table width="100%" innerWidth={['5%', '35%', '20%', '20%', '20%']}>
              <Thead>
                <Tr>
                  <Th position={0}>Sl.No.</Th>
                  <Th position={1}>College name</Th>
                  <Th position={2}>Date of Join</Th>
                  <Th position={3}>Address</Th>
                  <Th position={4}>Action</Th>
                </Tr>
              </Thead>
              <Tbody height="auto">
                {tableData?.filter((college: any) => college.status?.toLowerCase() !== 'rejected').length > 0 ? (
                  tableData
                    .filter((college: any) => college.status?.toLowerCase() !== 'rejected')
                    .map((college: any, i: number) => (
                      <Tr key={college._id}>
                        <Td index={i} position={0}>{i + 1}</Td>
                        <Td index={i} position={1} onClick={() => setSelectedCollege(college)}>
                          {college.collegeName || '-'}
                        </Td>
                        <Td index={i} position={2} onClick={() => setSelectedCollege(college)}>
                          {college.createdOn ? moment(college.createdOn).format('ddd-DD-MM-YYYY') : '-'}
                        </Td>
                        <Td index={i} position={3} onClick={() => setSelectedCollege(college)}>
                          {college.address || '-'}
                        </Td>
                        <Td index={i} position={4}>
                          <div className="flex gap-2">
                            <Button
                              type="submit"
                              onClick={() => setConfirmApproveCollege(college)} 
                              disabled={college.status?.toLowerCase() === 'approved'}
                            >
                              Approve
                            </Button>
                            <Button
                              type="delete"
                              onClick={() => setConfirmDeleteCollege(college)}
                              disabled={college.status?.toLowerCase() === 'approved'}
                            >
                              Delete
                            </Button>
                          </div>
                        </Td>
                      </Tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center py-4 text-gray-600">
                      No colleges awaiting approval.
                    </td>
                  </tr>
                )}
              </Tbody>
            </Table>
          </div>
        )}
      </Body>
    </Main>
  );
}

export default CollegeVerification;